export enum TAB {
  SERIES = "series",
  MATCH = "match",
  BETBUILDER = "betbuilder",
}
